import { render, staticRenderFns } from "./cptDetailsModal.vue?vue&type=template&id=5f180cf4&scoped=true&"
import script from "./cptDetailsModal.vue?vue&type=script&lang=js&"
export * from "./cptDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./cptDetailsModal.vue?vue&type=style&index=0&id=5f180cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f180cf4",
  null
  
)

export default component.exports